/** Display form of an arbitrary extracted value: `—` when absent, JSON for objects, `String` otherwise. */
export const formatValue = (v: unknown): string =>
  v === null || v === undefined ? '—' : typeof v === 'object' ? JSON.stringify(v) : String(v);
